import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SVGAPlayer from '../SVGAPlayer';
import './SVGAModal.css';

const SVGAModal = ({ 
    isOpen, 
    onClose, 
    animatedUrl, 
    giftName = 'Animation',
    size = 'medium'
}) => {
    const [isVisible, setIsVisible] = useState(false);

    React.useEffect(() => {
        if (isOpen) {
            setIsVisible(true);
        } else {
            const timer = setTimeout(() => setIsVisible(false), 300);
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    const handleClose = () => {
        onClose();
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    if (!isVisible) return null;

    return (
        <div 
            className={`svga-modal-overlay ${isOpen ? 'show' : ''}`}
            onClick={handleBackdropClick}
        >
            <div className="svga-modal-container">
                <div className="svga-modal-header">
                    <h3 className="svga-modal-title">
                        {giftName}
                    </h3>
                    <button 
                        className="svga-modal-close"
                        onClick={handleClose}
                        aria-label="Đóng"
                    >
                        ✕
                    </button>
                </div>
                
                <div className="svga-modal-body">
                    <SVGAPlayer
                        animatedUrl={animatedUrl}
                        giftName={giftName}
                        className={`modal-view ${size}`}
                        showControls={true}
                        autoPlay={true}
                        width="100%"
                        height="100%"
                    />
                </div>
            </div>
        </div>
    );
};

SVGAModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    animatedUrl: PropTypes.string,
    giftName: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large'])
};

export default SVGAModal; 